import { useEffect, useState } from "react"

/**
 * Custom hook to calculate and track scrollbar width
 * Sets a CSS custom property --scrollbar-width and returns the calculated width
 *
 * @returns {number} The current scrollbar width in pixels
 */
export default function useScrollbarWidth() {
  const [scrollbarWidth, setScrollbarWidth] = useState(0)

  useEffect(() => {
    const calculateScrollbarWidth = () => {
      // Create temporary element to measure scrollbar
      const outer = document.createElement("div")
      outer.style.visibility = "hidden"
      outer.style.overflow = "scroll"
      outer.style.msOverflowStyle = "scrollbar" // IE/Edge support
      document.body.appendChild(outer)

      const inner = document.createElement("div")
      outer.appendChild(inner)

      const width = outer.offsetWidth - inner.offsetWidth
      outer.parentNode.removeChild(outer)

      // Set CSS custom property for use in stylesheets
      document.body.style.setProperty("--scrollbar-width", `${width}px`)

      setScrollbarWidth(width)
      return width
    }

    // Calculate initially
    calculateScrollbarWidth()
  }, [])

  return scrollbarWidth
}
